import type { Membership } from '../auth/session'
import { presentation } from '../portalMode'

export interface Destination {
  to: string
  label: string
  end: boolean
  /** The capability the role must hold. `null` means everybody. */
  capability: string | null
}

/**
 * What the sidebar offers, per portal.
 *
 * Two lists rather than one list with conditions in it, because they are two
 * products' worth of vocabulary and the difference is the point. A business
 * customer looks for «مصرف و هزینه‌ها»; a development shop looks for
 * «درخواست‌ها», and those are the same rows underneath.
 *
 * Neither list gates anything. Every route in the application is reachable in
 * both modes — a service customer following a support link to the request
 * history arrives at the request history — these are the destinations the
 * portal *offers*, not the ones it permits.
 */
const SERVICE: Destination[] = [
  { to: '/', label: 'خانه', end: true, capability: null },
  { to: '/recharge', label: 'افزایش اعتبار', end: false, capability: 'view_wallet' },
  { to: '/usage', label: 'مصرف و هزینه‌ها', end: false, capability: 'view_requests' },
  { to: '/services', label: 'سرویس‌های من', end: false, capability: 'view_api_permissions' },
  { to: '/connection', label: 'اتصال نرم‌افزار', end: false, capability: 'view_applications' },
  { to: '/account', label: 'حساب کاربری', end: false, capability: null },
]

const PROFESSIONAL: Destination[] = [
  { to: '/', label: 'داشبورد', end: true, capability: null },
  { to: '/services', label: 'سرویس‌ها', end: false, capability: 'view_api_permissions' },
  { to: '/connection', label: 'اتصال API', end: false, capability: 'view_applications' },
  { to: '/wallet', label: 'کیف پول', end: false, capability: 'view_wallet' },
  { to: '/requests', label: 'درخواست‌ها', end: false, capability: 'view_requests' },
  { to: '/docs', label: 'مستندات', end: false, capability: null },
  { to: '/account', label: 'حساب کاربری', end: false, capability: null },
]

export function destinationsFor(membership: Membership): Destination[] {
  return presentation(membership).isService ? SERVICE : PROFESSIONAL
}
